import { CerFormAdapter } from "@form/cer-form-adapter";
import { CerFormView } from "@form/cer-form-view";

export class RoyaltyPeriodForm extends CerFormAdapter {

    public override view(): CerFormView {
        return new CerFormView({
            viewMetadata: {
                name: 'royaltyPeriods', dataApiName: 'RoyaltyDatoer', text: 'Perioder', textSingular: 'Periode',
                primaryKey: 'id', titleFields: ['royaltyDato'], baseFields: ['id', 'history']
            },
            fieldMetadata:
                [
                    { name: 'aktuel', text: 'Aktuel', tooltipText: 'Er dette den aktuelle periode', allowEdit: true, allowEditOnAdd: true, format: 'CheckBox' },
                    { name: 'royaltyDato', text: 'Periode slut', tooltipText: 'Slutdato for perioden', required: true, allowEdit: true, allowEditOnAdd: true, format: 'DateShort', orderBy: 'Descending' },
                    { name: 'forrige', text: 'Forrige', tooltipText: 'Slutdato for forrige periode', required: true, allowEdit: true, allowEditOnAdd: true, format: 'DateShort' }
                ]
        });
    }
}